import { Reveal } from "../common/Reveal";

export default function Positioning() {
  return (
    <section className="relative py-28 md:py-40 border-t border-kv-steel/10" data-testid="section-positioning">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-4xl">
          <Reveal>
            <p className="font-display text-3xl sm:text-4xl md:text-5xl font-medium tracking-tight leading-[1.15] text-kv-steel">
              Growth does not come from adding more tools.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-6 font-display text-3xl sm:text-4xl md:text-5xl font-medium tracking-tight leading-[1.15] text-kv-off text-balance">
              It comes from building one intelligent operating system around your business.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
